import PropTypes from 'prop-types';
import {
  // Avatar,
  Box,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import Loader from 'react-loader-spinner';

const NotificationPageKoala = ({ product, loaderstate, ...rest }) => (
  <Card
    sx={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%'
    }}
    {...rest}
  >
    <CardContent>
      {loaderstate ? (
        <Box sx={{ minWidth: 1350 }}>
          <Loader
            visible={loaderstate}
            type="Puff"
            color="#00BFFF"
            height={45}
            width={45}
            timeout={300000}
          />
        </Box>
      ) : null}
      {product && product.deliverychange ? (
        <Box sx={{ minWidth: 1350 }}>
          <Table id="emp">
            <TableHead>
              <TableRow>
                <TableCell
                  colSpan={5}
                  style={{
                    height: '20px',
                    width: '20px',
                    padding: '20px',
                    fontSize: '21px',
                    margin: '20px',
                    textAlign: 'center',
                    color: '#ffff',
                    backgroundColor: 'black'
                  }}
                >
                  Rescheduled Deliveries
                </TableCell>
              </TableRow>
            </TableHead>
            <TableHead>
              <TableRow>
                <TableCell>Invoice no.</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Past Delivery</TableCell>
                <TableCell>Current Delivery</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {product
                && product.deliverychange
                && product.deliverychange.map((customer, index) => (
                  <TableRow hover key={index[1]}>
                    <TableCell>{customer.InvoiceId}</TableCell>
                    <TableCell>{customer.ItemName}</TableCell>
                    <TableCell>{customer.Quantity}</TableCell>
                    <TableCell>{customer.PastDelivery}</TableCell>
                    <TableCell>{customer.CurrentDelivery}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </Box>
      ) : null}
      {product && product.NewData ? (
        <Box sx={{ minWidth: 1350 }}>
          <Table id="emp">
            <TableHead>
              <TableRow>
                <TableCell
                  colSpan={5}
                  style={{
                    height: '20px',
                    width: '20px',
                    fontSize: '21px',
                    padding: '20px',
                    margin: '20px',
                    textAlign: 'center',
                    color: '#ffff',
                    backgroundColor: 'black'
                  }}
                >
                  New Added Deliveries
                </TableCell>
              </TableRow>
            </TableHead>
            <TableHead>
              <TableRow>
                <TableCell>Invoice no.</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>CBM</TableCell>
                <TableCell>Boxes</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {product
                && product.NewData
                && product.NewData.map((customer, index) => (
                  <TableRow hover key={index[1]}>
                    <TableCell>{customer.InvoiceId}</TableCell>
                    <TableCell>{customer.ItemName}</TableCell>
                    <TableCell>{customer.Quantity}</TableCell>
                    <TableCell>{customer.CBM}</TableCell>
                    <TableCell>{customer.Boxes}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </Box>
      ) : null}
      {product && product.RemovedData ? (
        <Box sx={{ minWidth: 1350 }}>
          <Table id="emp">
            <TableHead>
              <TableRow>
                <TableCell
                  colSpan={5}
                  style={{
                    height: '20px',
                    width: '20px',
                    padding: '20px',
                    fontSize: '21px',
                    margin: '20px',
                    textAlign: 'center',
                    color: '#ffff',
                    backgroundColor: 'black'
                  }}
                >
                  Remove Deliveries
                </TableCell>
              </TableRow>
            </TableHead>
            <TableHead>
              <TableRow>
                <TableCell>Invoice no.</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>CBM</TableCell>
                <TableCell>Boxes</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {product
                && product.RemovedData
                && product.RemovedData.map((customer, index) => (
                  <TableRow hover key={index[1]}>
                    <TableCell>{customer.InvoiceId}</TableCell>
                    <TableCell>{customer.ItemName}</TableCell>
                    <TableCell>{customer.Quantity}</TableCell>
                    <TableCell>{customer.CBM}</TableCell>
                    <TableCell>{customer.Boxes}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </Box>
      ) : null}

      {product && product.ModifiedData ? (
        <Box sx={{ minWidth: 1350 }}>
          <Table id="emp">
            <TableHead>
              <TableRow>
                <TableCell
                  colSpan={5}
                  style={{
                    height: '20px',
                    width: '20px',
                    padding: '20px',
                    fontSize: '21px',
                    margin: '20px',
                    textAlign: 'center',
                    color: '#ffff',
                    backgroundColor: 'black'
                  }}
                >
                  Modified Deliveries
                </TableCell>
              </TableRow>
            </TableHead>
            <TableHead>
              <TableRow>
                <TableCell>Invoice no.</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Past Quantity</TableCell>
                <TableCell>Current Quantity</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {product
                && product.ModifiedData
                && product.ModifiedData.map((customer, index) => (
                  <TableRow hover key={index[1]}>
                    <TableCell>{customer.InvoiceId}</TableCell>
                    <TableCell>{customer.ItemName}</TableCell>
                    <TableCell>{customer.PastQty}</TableCell>
                    <TableCell>{customer.CurrentQty}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </Box>
      ) : null}
    </CardContent>
  </Card>
);

NotificationPageKoala.propTypes = {
  product: PropTypes.object.isRequired,
  loaderstate: PropTypes.object.isRequired
};

export default NotificationPageKoala;
